// extracted by mini-css-extract-plugin
export default {"logoContainer":"LangToggle_logoContainer__uliC0","langSwitch":"LangToggle_langSwitch__XgL62"};